module.exports = __webpack_public_path__ + "img/credit-card.157ca87.png";